import { SocialMediaNetwork } from '@professocial/professocialTypes/types/commonTypes'

const countAllowedNetworks = (socialMediaNetwork?: SocialMediaNetwork) => {
  let counter = 0
  socialMediaNetwork && Object.keys(socialMediaNetwork).map((key: string) => {
    if (socialMediaNetwork[key]) {
      counter += 1
    }
  })
  return counter
}

export default countAllowedNetworks
